import { Lightning } from "@lightningjs/sdk";
import { MovieDetails } from "../../../../components/data-display/MovieDetails/MovieDetails";
import { MediaActions } from "../MediaActions/MediaActions";
import { TranslatableText } from "../../../../components/data-display/TranslatableText/TranslatableText";
import { Icon } from "../../../../components/data-display/Icon/Icon";
import { MediaModel } from "../../../../lib/models";
import theme from "../../../../lib/theme";
import { MENU_WIDTH } from "../../../../lib/utils";
import { MediaCategory } from "../../../../components/data-display/MediaCategory/MediaCategory";

interface SeriesDetailsCompactTemplateSpec extends Lightning.Component.TemplateSpec {
    Movie: {
        Top: {
            Category: typeof MediaCategory;
            Details: typeof MovieDetails;
            Buttons: typeof MediaActions;
        };
    };
    DetailsLabel: {
        Label: typeof TranslatableText;
        Icon: typeof Icon;
    };
}

export class SeriesDetailsCompact
    extends Lightning.Component<SeriesDetailsCompactTemplateSpec>
    implements Lightning.Component.ImplementTemplateSpec<SeriesDetailsCompactTemplateSpec>
{
    _selectedSeason = 0;
    _hasSeasons = false;
    _data!: MediaModel;

    static override _template(): Lightning.Component.Template<SeriesDetailsCompactTemplateSpec> {
        return {
            collision: true,
            w: theme.layout.w,
            x: MENU_WIDTH,
            Movie: {
                collision: true,
                Top: {
                    collision: true,
                    y: 0,
                    x: 0,
                    w: theme.banner.w,
                    h: theme.banner.h,
                    Details: {
                        type: MovieDetails
                    },
                    Buttons: {
                        collision: true,
                        x: theme.banner.padding.x,
                        y: theme.banner.h - (theme.banner.padding.y || theme.banner.padding.x) - 56,
                        // flexItem: { marginTop: 56 },
                        type: MediaActions
                    }
                }
            }
        };
    }

    readonly Movie = this.getByRef("Movie")!;
    readonly Top = this.Movie.getByRef("Top")!;
    readonly Buttons = this.Top.getByRef("Buttons")!;

    readonly Details = this.Top.getByRef("Details")!;

    set data(movie: MediaModel) {
        // window.selectedMovie = movie;

        this._data = movie;

        // this.application.emit("updateSelectedMovie", window.selectedMovie);
        //
        // this.application.emit("clearBackground");
        // this.application.emit("updateSelectedMovie", movie);

        this.Details.patch({
            data: movie
        });

        this.Buttons.patch({
            data: movie
        });
    }

    override _getFocused(): any {
        return this.Buttons;
    }
}
